<template> 
    <div>
        <div style="display: flex;background-color: white;padding-bottom: 5px;">
            <el-upload class="upload-demo" :show-file-list="false" :action="fileUploadURL" 
                :headers="uploadHeaders" :on-success="handleSuccess" :before-upload="beforeUpload" accept=".xlsx">
                <el-button size="mini">选择文件</el-button>
            </el-upload>
            <el-button type="primary" plain size="mini" @click="importDS" style="margin-left: 10px;">导入东胜系统</el-button>
        </div>

        <el-table size="mini" :data="tableData" style="width: 100%;" height="700" v-loading="loading"
        :header-cell-style="{'text-align':'center','background':'#f8f8f9'}">
            <el-table-column prop="no" label="序号" width="50" />
            <el-table-column prop="seqNo" label="统一编号"  width="140" />
            <el-table-column prop="shipName" label="运输工具名称" width="140" />
            <el-table-column prop="voyNo" label="航次号" width="140" />
            <el-table-column prop="billNo" label="提运单号" width="140" />
            <el-table-column prop="ieFlag" label="进出口标志" width="140" />
            <el-table-column prop="entryDate" label="申报日期 " width="140" />
            <el-table-column prop="entryNo" label="报关单号" width="140" />
            <el-table-column prop="type" label="监管方式" width="140" />
            <el-table-column prop="contractNo" label="合同协议号" width="140" />
            <el-table-column prop="cosMaster" label="申报地海关" width="140"/>
            <el-table-column prop="receiveName" label="境内收发货人" width="140" />
            <el-table-column prop="dongshengCustomer" label="东胜客户" width="140" />
            <el-table-column prop="country" label="启运国/运抵国(地区) " width="140" />
            <el-table-column prop="tradeType" label="成交方式" width="140" />
            <el-table-column prop="packageNum" label="件数" width="140" />
            <el-table-column prop="gross" label="毛重(KG)" width="140" />
            <el-table-column prop="net" label="净重(KG)" width="140" />
            <el-table-column prop="note" label="备注" width="300" />
        </el-table>
    </div>
</template>
<script>
import * as XLSX from 'xlsx'
export default {
    data() {
        return {
            tableData:[],
            loading:false,
            fileUploadURL:process.env.VUE_APP_BASE_API + 'cms/impExcel/swBill',
            uploadHeaders: {
                token:localStorage.getItem('token'),
            }
        }
    },
    mounted() { 
        
    },
    methods: { 
        beforeUpload(flie){
            this.loading = true;
        },
        handleSuccess(response, file, fileList){
            this.tableData = response.data
            this.loading = false;
        },
        handleError(err, file, fileList) {
            this.loading = false;
            this.$message.error('文件上传失败');
            // 处理 token 过期的情况
            if (err.status === 401) {
                this.$message.error('登录已过期，请重新登录');
                // 跳转到登录页或其他处理
            }
        },
        // 导入东胜系统
        importDS(){
            this.$confirm('确认导入东胜系统吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.insData( this.tableData ).then(res =>{
                    this.tableData = []
                    this.$message({
                        message: '导入成功',
                        type: 'success'
                    });
                })
            }).catch(() => {});
        }
    }
}
</script>
<style lang="css" scoped>
.el-table {
    margin-top: 0px !important;
}
</style>